import { Component, OnInit, Input,NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';

import { DomSanitizer,SafeResourceUrl } from '@angular/platform-browser';

import { PhysicalcertificateComponent } from '../../../studentportal/components/physicalcertificate/physicalcertificate.component';
import { OtherCoursesInfoComponent } from '../../../studentportal/components/OtherCoursesInfo/OtherCoursesInfo.component';
import { Configuration } from '../../../app.constants';
@Component({
  selector: 'documentview4',
  templateUrl: './documentview4.component.html',
  styleUrls: ['./documentview4.component.scss']
})
export class Documentview4Component implements OnInit {
  @Input()
  documentURL:string;
  
  @Input()
  documentId:string;
  
  docPDFUrl:SafeResourceUrl;
  
  //documentId: string = 'lp-EO5I60KA';
  urlCache = new Map<string, SafeResourceUrl>();
  LanguageLabel: any;
  constructor(public sanitizer: DomSanitizer,
    public OtherCoursesInfoComponent:OtherCoursesInfoComponent,
    private Configuration:Configuration){}
  
    ngOnInit() {  
      this.LanguageLabel =this.Configuration.LanguageLabel[0];
    }
    
    stillLoading = true;
    afterComplete(){
      this.stillLoading = false;
    }
  
    pdfURL() {
      return this.sanitizer.bypassSecurityTrustResourceUrl(this.documentURL);
    }
  
    getIframeUrl(): SafeResourceUrl {
      const url = this.urlCache.get(this.documentId);
      if (!url) {
       var url1 = this.sanitizer.bypassSecurityTrustResourceUrl(this.documentURL);
        this.urlCache.set(this.documentId, url1);
      }
      return url;
    }
  
    cancelClick() {
      this.OtherCoursesInfoComponent.popupVisible=false;
    }
  
  }
  @NgModule({
    imports: [
      CommonModule
    ],
    exports: [
      Documentview4Component,
    ],
    declarations: [
      Documentview4Component
    ]
  })
  export class  DocumentView4Module {}
  